import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { useTooltipContext } from 'components';
import styles from './Icon.module.scss';

export type IconProps = {
    className?: string,
    icon: IconDefinition,
    size?: string,
    svgClassName?: string,
    title?: string
};

export const Icon = ({ className, icon, size='1x', svgClassName, title }: IconProps) => {
    const {
        icon: [x, y, a, b, d],
        iconName,
        prefix
    } = icon;
    const { onBlur, onKeyDown, onMouseDown, onMouseOut, onMouseOver } = useTooltipContext();

    return (
        <div
            className={`${styles.container} ${className}`}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onMouseDown={onMouseDown}
            onMouseOut={onMouseOut}
            onMouseOver={onMouseOver}
            tabIndex={title ? 0 : undefined}
            title={title}
        >
            <svg
                className={`svg-inline--fa fa-${iconName} fa-${size} ${svgClassName}`}
                data-icon={iconName}
                data-prefix={prefix}
                role="img"
                viewBox={`0 0 ${x} ${y}`}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d={d as string} fill="currentColor" />
            </svg>
        </div>
    );
};